import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../shared/services/user.service';
import { CommonService } from '../../../shared/services/common.service';
import { environment } from '../../../../environments/environment';
import { Router, NavigationEnd, Event, NavigationStart, NavigationError, RoutesRecognized } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public mobile = '';
  public password = '';
  public errorOccurred = false;
  public errorOccurredMessage = '';
  successMobile: boolean = false;
  errorMobileMessage = "";
  successPassword: boolean = false;
  errorPasswordMessage = "";
  page_name = localStorage.getItem('front-lang') == 'ar' ? "تسجيل دخول" : "Login";
  

  constructor(private user: UserService, private coomenservice: CommonService, private router: Router) { }

  ngOnInit(): void {
  }



  userLogin() {
    this.errorOccurred = false;
    this.errorOccurredMessage = "";

    if (this.mobile == '') {
      this.successMobile = true;
      this.errorOccurred = true;
      this.errorOccurredMessage = "Enter Valid Mobile";
      return;
    }

    if (this.password == '') {
      this.successPassword = true;
      this.errorOccurred = true;
      this.errorOccurredMessage = "Enter Valid Password";
      return;
    }

    if (this.successMobile === true || this.successPassword === true) {
      return;
    } else {
      let body = {
        "mobile": this.mobile,
        "password": this.password,
      }

      this.user.userLogin(body).subscribe((data) => {
        if (data.data) {

          localStorage.setItem("clientToken", data.data.authentication_code);
          localStorage.setItem("affiliatorToken", environment.affiliator_token);
          localStorage.setItem("currentUserFront", JSON.stringify(data.data));

          // Call Merge API To Merge Cart List
          this.user.shareCartList().subscribe(data => {
            console.log(JSON.stringify(data));
          });

          this.user.userLoggedIn(data.data.user_name);
          if (localStorage.getItem('previousUrl') !== '' && localStorage.getItem('previousUrl') != null && localStorage.getItem('previousUrl') != '/pages/my-account') {
            this.router.navigate([localStorage.getItem('previousUrl')]);
          } else {
            this.router.navigate(['/pages/dashboard']);
          }

        } else {
          this.errorOccurred = false;
          this.errorOccurredMessage = '';
          if (data.success == false) {
            this.errorOccurred = true;
            this.errorOccurredMessage = data.message;
          }
          return;
        }
      });

      // this.user.shareCartList(body).subscribe(success => {
      //   console.log(success);
      // });

    }
  }

}
